import type { ReactNode } from 'react';
import { useAuth, useIdleTimer } from '@claim-os/shared';
import { IDLE_ACTIVITY_CHANNEL_NAME, IDLE_TIMEOUT_MS, WARNING_LEAD_MS } from '../idleTimeoutConfig';
import { IdleWarningModal } from './IdleWarningModal';

interface SessionTimeoutProviderProps {
  children: ReactNode;
}

/**
 * Signs the user out after IDLE_TIMEOUT_MS with no interaction (FR-001, FR-002), warning them
 * WARNING_LEAD_MS beforehand with a cancelable countdown (FR-003, FR-004, FR-005). Only active
 * while authenticated (FR-008) — there is no session to end otherwise. Interaction in any tab
 * keeps every tab's session alive (FR-006).
 */
export function SessionTimeoutProvider({ children }: SessionTimeoutProviderProps) {
  const { isAuthenticated, logout } = useAuth();

  const { isWarning, remainingMs, reset } = useIdleTimer({
    idleTimeoutMs: IDLE_TIMEOUT_MS,
    warningLeadMs: WARNING_LEAD_MS,
    onIdle: logout,
    enabled: isAuthenticated,
    channelName: IDLE_ACTIVITY_CHANNEL_NAME,
  });

  return (
    <>
      {children}
      <IdleWarningModal open={isWarning} remainingMs={remainingMs} onStaySignedIn={reset} />
    </>
  );
}
